import Maintainers from "@/pages/Maintainers/Maintainers";
import MaintainersCustomers from "@/pages/Maintainers/Customers/Customers";
import MaintainersAptitudes from "@/pages/Maintainers/Aptitudes/Aptitudes";
import MaintainersProducts from "@/pages/Maintainers/Products/Products";
import MaintainersDealers from "@/pages/Maintainers/Dealers/Dealers";
import MaintainersApplications from "@/pages/Maintainers/Applications/Applications";
import MaintainersUsers from "@/pages/Maintainers/Users/Users";
import MaintainersVersions from "@/pages/Maintainers/Versions/Versions";
import MaintainersBalance from "@/pages/Maintainers/Balances/Balances";
import MaintainersCodes from "@/pages/Maintainers/Codes/Codes";
import MaintainersHelpCenter from "@/pages/Maintainers/HelpCenter/HelpCenter";
import MaintainersWeb from "@/pages/Maintainers/Web/Web";
import MaintainersWebContent from "@/pages/Maintainers/WebContent/WebContent";
import MaintainersActiveIngredients from "@/pages/Maintainers/ActiveIngredients/ActiveIngredients";
import MaintainersIncidents from "@/pages/Maintainers/Incidents/Incidents";
import MaintainersSAGSpecies from "@/pages/Maintainers/Crops/Crops";

const adminRole = () => ["administrador"];

export const maintainersRoutes = [
	{
		path: `/mantenedores/clientes/:option?/:customer_id?`,
		Component: MaintainersCustomers,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/especies/:option?/:element_id?`,
		Component: MaintainersSAGSpecies,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/codigos/:option?/:code_id?`,
		Component: MaintainersCodes,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/productos/:option?/:product_id?`,
		Component: MaintainersProducts,
		roles: [...adminRole(), "mantenimiento"],
	},
	{
		path: `/mantenedores/usuarios/:option?/:slug?`,
		Component: MaintainersUsers,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/aptitudes/:option?/:aptitude_id?`,
		Component: MaintainersAptitudes,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/distribuidores/:option?/:dealer_id?`,
		Component: MaintainersDealers,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/versiones/:option?/:version_id?`,
		Component: MaintainersVersions,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/balanzas/:option?/:balance_id?`,
		Component: MaintainersBalance,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/ingredientes_activos/:option?/:active_ingredient_id?`,
		Component: MaintainersActiveIngredients,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/`,
		Component: Maintainers,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/incidencias/:option?/:selected?`,
		Component: MaintainersIncidents,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/paginas_web/:option?/:selected?`,
		Component: MaintainersWeb,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/contenidos_web/:option?/:selected?`,
		Component: MaintainersWebContent,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/centro_ayuda`,
		Component: MaintainersHelpCenter,
		roles: adminRole(),
	},
	{
		path: `/mantenedores/aplicaciones/:action?/:application_history_id?`,
		Component: MaintainersApplications,
		roles: [...adminRole(), "gerente_agricola", "administrador_campo"],
	},
];
